import React from "react"
import { twMerge } from "tailwind-merge"

import { FilePicker } from "../../components/shared/FileStackWidgets"
import { BASE_INPUT_CLASSNAMES, Label } from "../../components/shared/Inputs"
import LoadingSpinner from "../../components/shared/LoadingSpinner"
import { useToast } from "../../contexts/ToastContext"

import { useBookableEventTypes } from "./BookableEventTypesContext"

const PhotoUpload = () => {
  const { bookableEventType, setBookableEventType, fetching, removePhoto, updateBookableEventTypes } =
    useBookableEventTypes()

  const { showToast } = useToast()

  const onUploadDone = (res) => {
    const file = res.filesUploaded[0]
    setBookableEventType((prev) => ({
      ...prev,
      photoUrl: file.url, // For preview
      stagedPhotoHandle: file.handle // To be used on save
    }))
    showToast("Photo selected. It will be applied when you save.")
  }

  const onPhotoDelete = () => {
    // If a photo is staged, just remove it from state.
    if (bookableEventType.stagedPhotoHandle) {
      setBookableEventType((prev) => {
        const { ...rest } = prev
        return rest
      })
      showToast("Staged photo was removed.")
      return
    }

    // If it's a persisted photo, call the backend to delete it.
    removePhoto({ id: bookableEventType.id }).then((result) => {
      if (result?.data?.removeBookableEventTypePhoto?.result === "success") {
        const newEventType = { ...bookableEventType, photoUrl: null }
        setBookableEventType(newEventType)
        updateBookableEventTypes(newEventType)
        showToast("Your photo has been removed.")
      } else {
        console.error(result) // eslint-disable-line no-console
        let errorMessage =
          "There was an error removing your event type photo. Please try again later or contact support."
        if (result.data?.removeBookableEventTypePhoto?.errors)
          errorMessage += ` ${result.data.removeBookableEventTypePhoto.errors}`
        showToast({
          type: "error",
          content: errorMessage
        })
      }
    })
  }

  return (
    <>
      <div className="flex justify-between">
        <Label htmlFor="photo">Photo</Label>
        {!bookableEventType.photoUrl && <div className="text-sm text-gray-dark">Optional</div>}
      </div>
      {fetching ? (
        <LoadingSpinner className="py-0" />
      ) : bookableEventType.photoUrl ? (
        <div className="flex items-center gap-4">
          <img src={bookableEventType.photoUrl} alt="Event type photo" className="h-16 w-16 rounded-lg" />
          <div>
            <FilePicker
              as="button"
              className="font-bold text-teal"
              onUploadDone={onUploadDone}
              disabled={fetching}
              transformations={{}}>
              Edit photo
            </FilePicker>
          </div>
          <button className="font-bold text-red" onClick={onPhotoDelete}>
            Remove
          </button>
        </div>
      ) : (
        <FilePicker
          as="button"
          onUploadDone={onUploadDone}
          disabled={fetching}
          transformations={{}}
          className={twMerge(BASE_INPUT_CLASSNAMES, "rounded-lg border-2 border-dashed text-teal")}>
          + Upload photo
        </FilePicker>
      )}
    </>
  )
}

export default PhotoUpload
